import { cn } from "@/common/helpers/utils";
import { DetailActions } from "@/components/detail-page/detail-actions";
import type { DetailAction } from "@/components/detail-page/types";
import type { ReactElement, ReactNode } from "react";

interface DetailHeaderProps {
  icon?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  badges?: ReactNode;
  actions?: DetailAction[];
  className?: string;
}

export function DetailHeader({ icon, title, subtitle, badges, actions, className }: DetailHeaderProps): ReactElement {
  return (
    <header className={cn("flex flex-wrap items-start justify-between gap-4", className)}>
      <div className="flex min-w-0 items-center gap-4">
        {icon && (
          <div className="bg-muted text-muted-foreground flex size-12 shrink-0 items-center justify-center rounded-lg [&_svg]:size-6">
            {icon}
          </div>
        )}
        <div className="flex min-w-0 flex-col gap-1">
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="truncate text-2xl font-semibold tracking-tight">{title}</h1>
            {badges}
          </div>
          {subtitle && <div className="text-muted-foreground truncate text-sm">{subtitle}</div>}
        </div>
      </div>
      <DetailActions actions={actions} />
    </header>
  );
}
